import { Component, Input, OnInit } from '@angular/core';

/**
 * Componente que muestra un estado vacío con un mensaje descriptivo cuando no
 * hay registros que presentar.
 */
@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent implements OnInit {
  @Input() mensaje: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
